import { render } from "./UmbrellaButton.vue?vue&type=template&id=43bcfa2d&scoped=true"
import script from "./UmbrellaButton.vue?vue&type=script&lang=js"
export * from "./UmbrellaButton.vue?vue&type=script&lang=js"

import "./UmbrellaButton.vue?vue&type=style&index=0&id=43bcfa2d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43bcfa2d"]])

export default __exports__